import amplitude from "amplitude-js"
import userGaveConsent from "./user_gave_consent"

function initAmplitude() {
  amplitude.getInstance().init(window.gon.amplitudeToken, null, {
    deferInitialization: true,
    includeUtm: true,
    includeReferrer: true,
    includeGclid: true,
    trackingOptions: {
      // eslint-disable-next-line camelcase
      ip_address: false
    }
  })
}

function initGoogleAnalytics() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", window.gon.ga4Account);
}

function initCustomerIO() {
  /* eslint-disable */
  window._cio = window._cio || [];
  _cio.methods = ["load","identify","track","page"];
  _cio.factory = function(method){
    return function(){
      _cio.push([method].concat(Array.prototype.slice.call(arguments,0)));
    };
  };
  for (var i = 0; i < _cio.methods.length; i++) {
    var m = _cio.methods[i];
    _cio[m] = _cio.factory(m);
  }
  /* eslint-enable */
}

function loadCustomerIO() {
  /* eslint-disable */
  var t = document.createElement("script"),
    s = document.getElementsByTagName("script")[0];
  t.async = true;
  t.id    = "cio-tracker";
  t.setAttribute("data-site-id", window.gon.customerioToken);
  // https://customer.io/docs/javascript-quick-start/#event-array-data
  t.setAttribute("data-use-array-params", "true");
  t.src = "https://assets.customer.io/assets/track.js";
  s.parentNode.insertBefore(t, s);
  /* eslint-enable */
}

function loadGoogleTagManager() {
  /* eslint-disable */
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":
      new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:'';j.async=true;j.src=
    "https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,"script","dataLayer",gon.googleTagManagerContainer);
  /* eslint-enable */
}

initAmplitude()
initCustomerIO()
initGoogleAnalytics()

userGaveConsent.then(() => {
  loadCustomerIO()
  loadGoogleTagManager()
  amplitude.getInstance().enableTracking()
})
